import React from 'react';

const SearchBox = ({ searchTerm, setSearchTerm }) => {
  return (
    <div className="w-full max-w-2xl mx-auto mb-8 mt-12 px-4">
      <div className="relative">
        <input
          type="text"
          placeholder="جستجوی پرسشنامه..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full px-6 py-4 text-base bg-zinc-800/90 text-white 
            placeholder:text-white/50 rounded-2xl
            border border-white/10 focus:border-white/20
            shadow-lg shadow-black/5 backdrop-blur-sm
            transition-all duration-300 outline-none
            hover:bg-zinc-800/95 focus:bg-zinc-800/95"
        />
        <svg
          className="absolute left-5 top-1/2 -translate-y-1/2 w-5 h-5 text-white/50"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>
      </div>
    </div>
  );
};

export default SearchBox;